"use strict";

define('controller/dashboard',['require','exports','module','marionette','./base','uikit/uikit','../templates','../config','../libs/dashboard.helper','../libs/route.helper','langs'],function (require, exports, module) {
  var Mn = require('marionette'),
    RegionController = require('./base'),
    UIKit = require('uikit/uikit'),
    Templates = require('../templates'),
    config = require('../config'),
    dashboardHelper = require('../libs/dashboard.helper'),
    RouteHelper = require('../libs/route.helper'),
    langs = require('langs');
  var ButtonView = UIKit.Button;
  var p = langs.phrase;
  var RootView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    template: Templates.IRB['dashboard']
  });
  var DashboardController = RegionController.extend({
    header: p('App.Title'),
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      app.execute('achievement:unlock', 'Check the dashboard');
      var root = new RootView(),
        newStudyBtn = new ButtonView({
          visible: !!app.authorities.findWhere({
            authority: 'ROLE_IRB_USER'
          }),
          attributes: {
            role: 'button',
            'aria-label': 'Create a new study'
          },
          text: 'New Study',
          icon: 'plus',
          color: 'primary',
          floated: 'right',
          link: RouteHelper.resolve('study:create')
        }),
        headerGrid = root.headerGrid,
        contentGrid = root.contentGrid,
        topContainer = root.topContainer;
      topContainer.add(newStudyBtn);
      root.$el.css(config.contentCss);
      function applyAuthority() {
        var authority = app.role.get('description');
        var buttons = dashboardHelper.buttons(authority, {
          settings: app.settings
        });
        var cards = dashboardHelper.cards(authority);
        var killMe = headerGrid.empty().concat(contentGrid.empty());
        _.defer(function () {
          _.invoke(killMe, 'destroy');
        });
        headerGrid.addAll(buttons).bindToVisibility();
        contentGrid.addAll(cards);
        _.chain(buttons.concat(cards)).pluck('collection').compact().invoke('fetch');
      }
      ;
      if (app.role.has('description')) {
        applyAuthority();
      }
      root.listenTo(app.role, 'change:description', applyAuthority);
      region.show(root);
      state.addPageDependencies([]);
    }
  });
  module.exports = DashboardController;
});

